function Dashboard(props) {
    return (<div style={{ marginTop: "200px" }}>
        <h1>TEST</h1>
    </div>);
}

export default Dashboard;